// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","header":"style_header__2HqJ7"};